export function definitionsofWorkingRelationships2027() {
return [   // Release 2026-10-06 10:30:01
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 1,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 399.102,
   left: 67.32,
   width: 94.614,
   height: 13.036
}
,
{
   page: 1,
   name: "Client Names Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 422.575,
   left: 116.453,
   width: 445.093,
   height: 13.036
}
,
{
   page: 1,
   name: "via", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 445.669,
   left: 141.491,
   width: 247.921,
   height: 13.036
}
,
{
   page: 1,
   name: "Signature Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 480.146,
   left: 48.6327,
   width: 287.1503,
   height: 13.036
}
,
{
   page: 1,
   name: "Agent Brokerage Manager Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 514.724,
   left: 205.593,
   width: 359.674,
   height: 13.036
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 536.746,
   left: 166.451,
   width: 401.009,
   height: 13.036
}
] }
